// Charts
export function generateTableResultChartDataSeries(data, name, pointFormat = null) {
  return {
    name: name,
    color: "var(--kdiagram-power-prediction-points-color)",
    type: "scatter",
    zIndex: 400,
    data: data,
    marker: {
      enabled: true,
      symbol: "circle",
      radius: 3.5,
    },

    animation: false,
    states: {
      hover: {
        enabled: false,
      },
      normal: {
        animation: false,
      },
      inactive: {
        opacity: 0.2,
      },
    },
    tooltip: {
      pointFormat: pointFormat
    },
  };
}
